import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import BiotechIcon from "@mui/icons-material/Biotech";
import CampaignIcon from "@mui/icons-material/Campaign";
import GroupsIcon from "@mui/icons-material/Groups";
import HubIcon from "@mui/icons-material/Hub";
import WaterIcon from "@mui/icons-material/Water";

const cardStyle = {
  bgcolor: "#fff",
  color: "#4f4f4f",
  "&:hover": {
    color: "#fff",
    bgcolor: "#000",
    borderTop: "5px solid #9DCC49",
  },
};

const objectList = [
  {
    icon: (
      <CampaignIcon
        fontSize="large"
        sx={{
          color: "#317ABE",
          width: 52,
          height: 52,
          "&:hover": { color: "#fff" },
        }}
      />
    ),
    title: "Educate and Raise Awareness",
    subtitle:
      "Develop educational materials to inform the public about the impact of climate change on oceans and the potential of sustainable aquaculture.",
  },
  {
    icon: (
      <HubIcon
        fontSize="large"
        sx={{
          color: "#317ABE",
          width: 52,
          height: 52,
          "&:hover": { color: "#fff" },
        }}
      />
    ),
    title: "Collaborate and Network",
    subtitle:
      "Build partnerships with other NGOs, governmental bodies, businesses, and academic institutions. Collaboration can amplify your impact and bring diverse expertise to your cause.",
  },
  {
    icon: (
      <GroupsIcon
        fontSize="large"
        sx={{
          color: "#317ABE",
          width: 52,
          height: 52,
          "&:hover": { color: "#fff" },
        }}
      />
    ),
    title: "Engage with Communities",
    subtitle:
      "Involve local communities in your initiatives. Consider their needs and perspectives when implementing projects related to aquaculture and the blue economy.",
  },
  {
    icon: (
      <BiotechIcon
        fontSize="large"
        sx={{
          color: "#317ABE",
          width: 52,
          height: 52,
          "&:hover": { color: "#fff" },
        }}
      />
    ),
    title: "Research and Innovation",
    subtitle:
      "Support and promote research on innovative and sustainable aquaculture technologies.Encourage the development of eco-friendly aquaculture methods that reduce carbon footprint and environmental impact.",
  },
];

const Approach = () => {
  return (
    <Box margin={{ xs: "5% 0% 20% 0%", sm: "5% 0%" }}>
      <Typography
        variant="h6"
        color="#9DCC49"
        fontWeight={800}
        paddingTop={"2%"}
        paddingBottom={"2%"}
        textAlign={"left"}
      >
        <Box component={"span"}>
          <WaterIcon
            sx={{
              width: 23,
              height: 23,
            }}
          />
        </Box>{" "}
        Our Approach
      </Typography>
      <Typography
        variant="h3"
        color="#317ABE"
        fontWeight={800}
        paddingBottom={"2%"}
        textAlign={"left"}
      >
        Combines awareness-building, community engagement, and sustainable
        development practices.
      </Typography>
      <Grid container spacing={1}>
        {objectList.map((list, index) => {
          const { title, icon, subtitle } = list;
          return (
            <>
              <Grid item xs={12} sm={6} md={3}>
                <Box
                  key={index}
                  component={Card}
                  height={"100%"}
                  padding={"10% 8%"}
                  display={"flex"}
                  flexDirection={"column"}
                  width={{ xs: "100%", sm: "100%" }}
                  margin={{ xs: "4% 0%", sm: "4% 0%" }}
                  data-aos={"fade-down"}
                  sx={{ ...cardStyle }}
                >
                  <Box marginLeft={"2%"}>{icon}</Box>
                  <Typography variant={"h6"} fontWeight={700} paddingTop={"6%"}>
                    {title}
                  </Typography>
                  <Typography variant={"subtitle2"} paddingTop={"6%"}>
                    {subtitle}
                  </Typography>
                </Box>
              </Grid>
            </>
          );
        })}
      </Grid>
    </Box>
  );
};

export default Approach;
